import { useEntry, Loading, ErrorBox, IntegrityNote } from "./entryShared";

const INF = { high: "bg-slate-900 text-white", medium: "bg-slate-500 text-white", low: "bg-slate-200 text-slate-600" };

export const CaseStakeholders = ({ caseId }) => {
  const { data, error } = useEntry(caseId, "/stakeholders");
  if (error) return <ErrorBox error={error} />;
  if (!data) return <Loading />;
  return (
    <div data-testid="case-stakeholders" className="mt-4">
      <p className="text-xs text-slate-500 mb-4">{data.total} stakeholders mapped · {data.with_documented_interest} with documented evidence of interest</p>
      {!data.groups?.length && (
        <p className="text-xs text-slate-400 border border-dashed border-slate-300 bg-white px-4 py-8 text-center" data-testid="stakeholders-empty">
          Stakeholder map not yet developed for this case.</p>
      )}
      <div className="space-y-5">
        {(data.groups || []).map((g) => (
          <div key={g.category} data-testid={`stk-group-${g.category.replaceAll(" ", "-").toLowerCase()}`}>
            <p className="text-[10px] uppercase tracking-widest text-slate-400 font-bold mb-2">{g.category}</p>
            <div className="space-y-2">
              {g.stakeholders.map((s) => (
                <div key={s.id} className="border border-slate-200 bg-white p-4" data-testid={`stk-${s.id}`}>
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <p className="text-xs font-bold text-slate-900">{s.name}</p>
                    <span className={`px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${INF[s.decision_influence]}`}>{s.decision_influence} influence</span>
                  </div>
                  <p className="text-[11px] text-slate-600 mt-1">{s.role}</p>
                  <p className="text-[10px] text-slate-400 mt-1 italic">{s.influence_basis}</p>
                  <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-2 mt-3 text-[11px]">
                    <div><p className="text-[9px] uppercase tracking-widest text-slate-400">Stage of involvement</p><p className="text-slate-700">{s.stage_of_involvement}</p></div>
                    <div><p className="text-[9px] uppercase tracking-widest text-slate-400">Evidence of interest</p><p className={s.evidence_of_interest ? "text-slate-700" : "text-slate-400"}>{s.evidence_of_interest || "None documented"}</p></div>
                    <div><p className="text-[9px] uppercase tracking-widest text-slate-400">Engagement objective</p><p className="text-slate-700">{s.engagement_objective}</p></div>
                    <div><p className="text-[9px] uppercase tracking-widest text-slate-400">Recommended timing</p><p className="text-slate-700">{s.recommended_timing}</p></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <IntegrityNote text={data.integrity_note} />
    </div>
  );
};
